import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
// import { Http } from '@angular/http';


import'rxjs/add/operator/toPromise';
import { Observable } from 'rxjs/Observable';
import'rxjs/add/operator/catch';
import'rxjs/add/operator/map';

import { ConfigService } from '../config/config.service';
export class ProductImageService {
    title = 'Product Service';
private productsUrl = '';
private productImageUrl = '';
private config: any;
/**
 * @param {?} http
 * @param {?} configService
 */
constructor(
private http: Http,
        configService: ConfigService
    ) {
        configService.getConfig((configuration: any) => {
            this.config = configuration;
            this.productsUrl = this.config.baseUrl + '/products';
            this.productImageUrl = this.config.baseUrl + '/products/images';
        });
    }
/**
 * @param {?} error
 * @return {?}
 */
private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
/**
 * @param {?} fileType
 * @param {?} productId
 * @return {?}
 */
getMainImageSignature(fileType: string, productId: string): Observable<any> {
        const /** @type {?} */ url = this.productImageUrl + '/sign?file_name=main.jpg&file_type=' + fileType + '&product_id=' + productId;
        return this.http.get(url).map(res => res.json());
    }
/**
 * @param {?} fileType
 * @param {?} productId
 * @param {?} fileName
 * @return {?}
 */
getImageSignature(fileType: string, productId: string, fileName: string): Observable<any> {
        const /** @type {?} */ url = this.productImageUrl + '/sign?file_name=' + fileName + '&file_type=' + fileType + '&product_id=' + productId;
        return this.http.get(url).map(res => res.json());
    }
/**
 * @param {?} fileType
 * @param {?} productId
 * @return {?}
 */
getDeleteMainImageAuthorizationHeader(fileType: string, productId: string): Observable<any> {
        const /** @type {?} */ url = this.productImageUrl + '/authorizationheader?file_name=main.jpg&file_type=' + fileType + '&product_id=' + productId;
        return this.http.get(url).map(res => res.json());
    }
/**
 * @param {?} productId
 * @return {?}
 */
deleteMainImage(productId: string): Observable<any> {
        const /** @type {?} */ url = this.productImageUrl + '/main?file_name=main.jpg&product_id=' + productId;
        return this.http.delete(url).map(res => res.json()).catch(this.handleError);
    }
/**
 * @param {?} imageId
 * @return {?}
 */
deleteImage(imageId: string): Observable<any> {
        const /** @type {?} */ url = this.productImageUrl + '/' + imageId;
        return this.http.delete(url).map(res => res.json()).catch(this.handleError);
    }
/**
 * @param {?} productId
 * @return {?}
 */
getProductImages(productId: string): Observable<any> {
        const /** @type {?} */ url = this.productsUrl + '/' + productId + '/images';
        return this.http.get(url).map(res => res.json()).catch(this.handleError);
    }
/**
 * @param {?} productId
 * @return {?}
 */
getMainProductImage(productId: string): Observable<any> {
        const /** @type {?} */ url = this.productsUrl + '/' + productId + '/mainProductImage';
        return this.http.get(url).map(res => res.json()).catch(this.handleError);
    }
/**
 * @param {?} file
 * @param {?} signed_request
 * @return {?}
 */
upload(file: any, signed_request: string) {
        let /** @type {?} */ headers = new Headers({
            'Content-Type': 'application/json',
            'x-amz-acl': 'public-read'
        });

        return this.http.put(
            signed_request,
            file,
            { headers: headers })
            .map(res => res.json());
    }
/**
 * @param {?} imageId
 * @return {?}
 */
moveImageUp(imageId: string): Observable<any> {
        const /** @type {?} */ url = this.productImageUrl + '/' + imageId + '/move-up';
        return this.http.put(url, null).map(res => res.json());
    }
/**
 * @param {?} imageId
 * @return {?}
 */
moveImageDown(imageId: string): Observable<any> {
        const /** @type {?} */ url = this.productImageUrl + '/' + imageId + '/move-down';
        return this.http.put(url, null).map(res => res.json());
    }

static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Http, },
{type: ConfigService, },
];
}

function ProductImageService_tsickle_Closure_declarations() {
/** @type {?} */
ProductImageService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ProductImageService.ctorParameters;
/** @type {?} */
ProductImageService.prototype.title;
/** @type {?} */
ProductImageService.prototype.productsUrl;
/** @type {?} */
ProductImageService.prototype.productImageUrl;
/** @type {?} */
ProductImageService.prototype.config;
/** @type {?} */
ProductImageService.prototype.http;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
